export const buildInternalLink = (article) =>
  article.category
    ? `/${article.category.slug.current}/${article.slug.current}`
    : '';
